/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'

import { Grid, FormLabel, Button, FormHelperText, Typography } from '@material-ui/core'

const styles = theme => ({
    formControl: {
        margin: theme.spacing(0)
    },
    buttons: {
        position: 'relative'
    },
    button: {
        width: '100%',
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5)
    },
    radio: {
        minWidth: '110px',
        alignItems: 'start'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        width: '100%'
    },
    errorText: {
        marginTop: theme.spacing(0.8),
        color: theme.palette.error.main + '!important',
        fontSize: '0.9rem!important',
        textAlign: theme.errorText && theme.errorText.textAlign ? theme.errorText.textAlign : 'center!important'
    },
    lgTitle: {
        fontSize: '1.5rem',
        marginBottom: theme.spacing(1.5),
        color: theme.palette.text.primary,
        lineHeight: 1.15
    },
    customTitleSize: {
        marginTop: theme.spacing(1)
    },
    optionHelper: {
        color: theme.body2Color,
        textAlign: theme.optionHelper ? theme.optionHelper.textAlign : ''
    },
    label: {
        marginBottom: theme.spacing(1.5) + 'px!important'
    },
    group: {
        marginTop: 15
    },
    imageSelectButton: {
        marginTop: theme.spacing(1.7),
        width: '100%',
        padding: 0,
        display: 'block'
    },
    buttonImage: {
        maxWidth: '100%',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        width: '100%',
        paddingTop: '75%'
    },
    buttonWithoutImage: {
        padding: 6
    },
    imageSelectLabel: {
        background: '#fff',
        paddingTop: 6,
        paddingBottom: 4,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4
    },
    selectedButtonImageLabel: {
        background: theme.palette.primaryColor,
        color: '#fff'
    },
    helperText: {
        marginTop: theme.spacing(1.5),
        fontSize: '0.875rem',
        color: theme.palette.text.primary,
        lineHeight: 1.43
    },
    [theme.breakpoints.down(600)]: {
        questionWrapper: {
            padding: '4px!important'
        }
    }
})

class ImageButtonsQuestion extends Component {
    handleChange = value => {
        this.props.onValueChanged(this.props.question.id, value)
    }

    render() {
        const { classes, question, value } = this.props

        return (
            <>
                <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)} className={classes.questionWrapper}>
                    {!question.titleSize && <FormLabel component="legend">{question.title}</FormLabel>}
                    {question.titleSize && (
                        <Typography variant={question.titleSize} gutterBottom className={classes.customTitleSize}>
                            {question.title}
                        </Typography>
                    )}
                    {question.description && <Typography component="span">{parse(question.description)}</Typography>}
                    <Grid container spacing={1}>
                        {question.options &&
                            question.options.map((option, key) => {
                                return (
                                    <Grid
                                        item
                                        xs={parseInt(option.xsCols)}
                                        sm={parseInt(option.smCols)}
                                        key={question.id + '|' + key}
                                        style={{ paddingBottom: 0 }}
                                    >
                                        <Button
                                            variant={value === option.value ? 'contained' : 'outlined'}
                                            color="primary"
                                            className={classes.imageSelectButton}
                                            style={value === option.value ? { color: 'white' } : null}
                                            onClick={() => this.handleChange(option.value)}
                                            key={key}
                                        >
                                            {option.image && (
                                                <>
                                                    <div
                                                        className={classes.buttonImage}
                                                        style={{
                                                            background: 'url("' + option.image + '")',
                                                            backgroundSize: 'cover'
                                                        }}
                                                    ></div>
                                                    <div
                                                        className={[
                                                            classes.imageSelectLabel,
                                                            value === option.value ? classes.selectedButtonImageLabel : null
                                                        ].join(' ')}
                                                    >
                                                        {option.label}
                                                    </div>
                                                </>
                                            )}
                                            {!option.image && <div className={classes.buttonWithoutImage}>{option.label}</div>}
                                        </Button>
                                        {option.description && <FormHelperText className={classes.optionHelper}>{option.description}</FormHelperText>}
                                    </Grid>
                                )
                            })}
                        {question.valid === false && (
                            <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                                <FormHelperText className={classes.errorText}>{question.errorMessage}</FormHelperText>
                            </Grid>
                        )}
                        {question.helperText && (
                            <Grid>
                                <FormHelperText className={classes.helperText}>{parse(question.helperText)}</FormHelperText>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </>
        )
    }
}

export default withStyles(styles)(ImageButtonsQuestion)
